import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSubscript32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconSubscript32"
            aria-hidden="true"
            {...props}
        >
            <g fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth={2}>
                <path strokeLinejoin="round" d="m7.344 21.657 11.313-11.314m-11.313 0 11.313 11.314" />
                <path d="M22.83 19.489 24.986 19v6.007" />
            </g>
        </svg>
    );
}
export default memo(IconSubscript32);
